/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React from 'react';
import './projectsPage.css';
import Header from '../components/header';
import Footer from '../components/footer';
import InvestAgent from '../components/investAgent';

function InvestorAgent() {
  return (
    <div className="main">
      <Header />
      <InvestAgent />
      <Footer />
    </div>
  );
}

export default InvestorAgent;
